export const appendGqlOp = ({ endpoint, gqlOp }) => {
  if (!gqlOp) return endpoint

  return `${endpoint}${endpoint.endsWith('/') ? '' : '/'}?gqlOp=${gqlOp}`
}
